import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
// import { fromPage } from '@blade-sxp/search-center/interfaces/enum';
import colors from '@/styles/color.scss';
let AlarmCenter = class AlarmCenter extends Vue {
    dialogVisible;
    collapseList;
    base64Image;
    loading;
    title;
    btnSearch;
    isShow = false;
    scale = 1;
    maxScale = 4;
    minScale = 0.5;
    activeNames = [];
    changeList = {};
    targetIndex = 0;
    disabled = false;
    activeNum = 0;
    // checkIndex: number = '0';
    getFeatureType(type) {
        if (type === 'OBJECT_FACE') {
            return true;
        }
        return false;
    }
    changeImg(index, val) {
        if (this.activeNum === index) {
            this.activeNum = NaN;
            this.disabled = true;
        }
        else {
            this.activeNum = index;
            this.disabled = false;
            this.changeList = val;
        }
        // let oldCheckIndex = NaN;
        // // 选中状态
        // if (val?.checkIndex === 0) {
        //   oldCheckIndex = val?.checkIndex;
        // } else {
        //   oldCheckIndex = val?.checkIndex ?? NaN;
        // }
        // console.log(index, val, '1111111111111');
        // const oldCheckIndex = val?.checkIndex ?? NaN;
        // const targetIndex = oldCheckIndex !== index ? index : NaN;
        // this.disabled = targetIndex !== index;
        // this.$set(val, 'checkIndex', targetIndex);
        // this.targetIndex = index;
        // console.log(oldCheckIndex, targetIndex, '1111111111111sss');
    }
    getFeatureLength(val) {
        if (val.featureList) {
            return val.featureList.length;
        }
        return 0;
    }
    getFeatureText(index) {
        if (this.activeNames === index) {
            return this.$t('hideAll');
        }
        return this.$t('showAll');
    }
    handleClose() {
        this.$emit('close');
    }
    search() {
        this.$emit('retrieval', this.changeList, this.targetIndex);
    }
    get conputeStyle() {
        const scale = this.scale;
        return {
            transform: `scale(${scale})`,
        };
    }
    changeCollapse(list, index) {
        this.drawFace(list);
        this.getFeatureText(index);
    }
    imageUrl(val) {
        this.disabled = false;
        if (val) {
            this.activeNames = [];
            this.collapseList?.forEach((item) => {
                if (item.featureType === 'OBJECT_FACE') {
                    this.activeNum = 0;
                    this.changeList = item.featureList?.[0];
                    this.drawFace(item.featureList);
                }
            });
        }
    }
    drawFace(vertices) {
        // 重复获取
        this.$nextTick(() => {
            const canvas = this.$refs.mycanvas;
            if (!canvas) {
                return false;
            }
            // 可以理解为一个画笔，可画路径、矩形、文字、图像
            const context = canvas.getContext('2d');
            const img = new Image();
            img.src = this.base64Image;
            img.crossOrigin = '';
            // 加载图片
            img.onload = () => {
                if (img.complete) {
                    // 根据图像重新设定了canvas的长宽
                    const { height, width } = img;
                    canvas?.setAttribute('width', String(width));
                    canvas?.setAttribute('height', String(height));
                    // 绘制图片
                    context?.drawImage(img, 0, 0, width, height); // 画布大小
                    context.strokeStyle = colors.white; // 矩形线颜色
                    // context.lineWidth = 1; // 矩形线宽
                    vertices?.forEach((item, index) => {
                        if (item) {
                            const cv = this.$refs.matting;
                            const cv1 = cv?.getContext('2d');
                            let imageData = {};
                            const verticesData = item.boundingPoly.vertices;
                            const x = verticesData[0].x;
                            const y = verticesData[0].y;
                            const rightX = verticesData[1].x - x;
                            const rightY = verticesData[1].y - y;
                            const startX = x * width;
                            const startY = y * height;
                            const endX = Math.abs(rightX * width);
                            const endY = Math.abs(rightY * height);
                            context?.strokeRect(startX, startY, endX, endY); // 绘制矩形 X y 长 宽
                            imageData = context?.getImageData(startX, startY, endX, endY);
                            cv1?.putImageData(imageData, 0, 0);
                            const base64Img = this.getCanvasImageData(imageData, endX, endY);
                            this.$emit('imageUrl', base64Img, index, vertices);
                        }
                    });
                }
            };
        });
    }
    getCanvasImageData(imgData, w, h) {
        const cv = document.createElement('canvas');
        const cv1 = cv?.getContext('2d');
        cv.width = w;
        cv.height = h;
        cv1?.putImageData(imgData, 0, 0, 0, 0, w, h);
        const base64Url = cv.toDataURL();
        cv.remove();
        return base64Url;
    }
    plus() {
        if (this.maxScale <= this.scale) {
            return (this.scale = this.maxScale);
        }
        this.scale += 0.1;
    }
    minus() {
        if (this.minScale >= this.scale) {
            return (this.scale = this.minScale);
        }
        this.scale -= 0.1;
    }
    mounted() { }
};
__decorate([
    Prop({ default: false })
], AlarmCenter.prototype, "dialogVisible", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "collapseList", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "base64Image", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "loading", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "title", void 0);
__decorate([
    Prop()
], AlarmCenter.prototype, "btnSearch", void 0);
__decorate([
    Watch('dialogVisible')
], AlarmCenter.prototype, "imageUrl", null);
AlarmCenter = __decorate([
    Component({
        name: 'SearchTag',
        components: {},
        i18n: {
            messages: {
                en: {
                    save: 'Save',
                    cancel: 'Cancel',
                    faceDetection: 'Face Detection',
                },
                zh: {
                    save: '保存',
                    cancel: '取消',
                    faceDetection: '人脸检测',
                },
            },
        },
    })
], AlarmCenter);
export default AlarmCenter;
